module.exports = __webpack_public_path__ + "img/nest.35e8d1f5.png";